import type { TypographyProps } from '@polyseme/design-system';

import { Typography as BaseTypography } from '@polyseme/design-system';
import { cn } from '@polyseme/utils/cn/cn-utils';

export const Typography = ({
  className,
  variant,
  ...props
}: TypographyProps) => {
  return (
    <BaseTypography
      className={cn(
        {
          'font-medium': variant === 'headline-2',
        },
        className
      )}
      variant={variant}
      {...props}
    />
  );
};
